import React from "react";

// import { Container } from './styles';

function Footer() {
  return (
    <div className="footer">
      <div className="copyright">
      </div>
    </div>
  );
}

export default Footer;
